import React from 'react';
import PropTypes from 'prop-types';
import UploadIcon from '../icons/upload.svg';

const UploadBox = ({ imageUrl, handleClick, className, style }) => {
  return (
    <div
      className={`flex items-center pt-6 justify-center ${className || ''}`}
      style={style}
      onClick={handleClick}
    >
      {imageUrl ? (
        <img src={imageUrl} alt="Preview" className="preview-image max-w-full max-h-full object-contain" />
      ) : (
        <div className="flex flex-col items-center justify-center">
          <img src={UploadIcon} alt="Upload Icon" className="upload-icon w-8 h-8" />
          {/* <div className="profile-upload-text">Logo</div> */}
        </div>
      )}
    </div>
  );
};

UploadBox.propTypes = {
  imageUrl: PropTypes.string,
  handleClick: PropTypes.func.isRequired,
  className: PropTypes.string,
  style: PropTypes.object,
};

UploadBox.defaultProps = {
  imageUrl: undefined,
  className: '',
  style: {},
};

export default UploadBox;